app.controller('businessIntelligenceController', ['$scope', '$state', '$mdToast', '$mdDialog', '$translate', 'objectHelper', 'applicationModel', 'saikuModel', 'visitModel', 'visitCardModel', 'config',
    function ($scope, $state, $mdToast, $mdDialog, $translate, objectHelper, applicationModel, saikuModel, visitModel, visitCardModel, config) {

        var availableRepoObjects = [
            'Patients_by_voivodenship.saiku',
            'Patients_by_voivodenship_allergy.saiku',
            'Patients_by_voivodenship_drugs.saiku',
            'Visits_by_voivodenship.saiku',
            'Visits_by_Country.saiku',
            'Patients_by_Country_Allergy.saiku',
            'Patients_by_Country_Drugs.saiku',
            'Visits_by_ICD9_Country.saiku',
            'Visits_by_ICD10_Country.saiku',
            'Visits_by_ICF_Country.saiku'
        ];

        function getFilesFromRepository(repository) {
            var files = [];
            repository.forEach(function (repoObject) {
                if(repoObject.type === 'FILE') {
                    files.push(repoObject);
                } else {
                    files = files.concat(getFilesFromRepository(repoObject.repoObjects));
                }
            });
            return files;
        }

        function setData() {
            $scope.raportsTypes = [
                {
                    name: $translate.instant('T.MODULE.PATIENT.PATIENTS'),
                    raports: []
                }, {
                    name: $translate.instant('T.UI.TAB.VISIT_LIST'),
                    raports: []
                }
            ];
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });

            $scope.$on(Event.SAIKU.GET_REPOSITORY.SUCCESS, function (event, repository) {
                var files = getFilesFromRepository(repository);
                files.forEach(function (file) {
                    if(file.name.indexOf('Visits') === 0) {
                        $scope.raportsTypes[1].raports.push(file);
                    } else if(file.name.indexOf('Patients') === 0) {
                        $scope.raportsTypes[0].raports.push(file);
                    }
                });
            });
        }

        function setActions() {
            $scope.showMap = function (repoObject) {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/bi/popup-bi-map.html',
                    controller: 'popupBusinessIntelligenceMapController',
                    resolve: {
                        repoObject: function () {
                            return repoObject;
                        }
                    }
                });
            };

            $scope.downloadPDF = function (repoObject) {
                var uuid = saikuModel.generateId();
                saikuModel.query(uuid, repoObject.path);
                var querySuccessDisabler =  $scope.$on(Event.SAIKU.QUERY.SUCCESS, function (event, data) {
                    querySuccessDisabler();
                    saikuModel.execute(data);
                });

                var executeSuccessDisabler =  $scope.$on(Event.SAIKU.EXECUTE.SUCCESS, function (event, data) {
                    executeSuccessDisabler();
                    saikuModel.downloadPDF(uuid, repoObject.name);
                });


            };

            $scope.goToSaiku = function () {
                window.open(config.SAIKU_APP, '_blank');
            };

            $scope.isMapAvailableForRepoObject = function (repoObject) {
                return availableRepoObjects.indexOf(repoObject.name) >= 0;
            };

            $scope.goBack = function () {
                $scope.goBack();
            };

            $scope.openUploadFilePopup = function() {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/bi/popup/bi-upload-file-popup.html',
                    controller: 'popupBusinessIntelligenceUploadFileController'
                }).then(function (data) {
                    $mdToast.show(
                        $mdToast.simple({
                            content: $translate.instant('T.MODULE.BASE_OF_CASE.FILE_HAS_BEEN_UPLOADED'),
                            hideDelay: 1500,
                            position: 'top right'
                        })
                    );

                }, function () {
                    //cancel
                });
            };
        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.HOME);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.UI.APPLICATION.HOME_PAGE');
        }

        function initialize() {
            applicationModel.viewReady = true;
            saikuModel.getRepository();
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
